import { jsx, jsxs } from 'react/jsx-runtime';
import { LineIcon } from '../ui/icons/LineIcon.js';
import { cn } from '../../lib/utils.js';

const InfoText = ({ text, type = "default", className, id }) => {
  const colorMap = {
    primary: ["bg-icon-primary-04", "text-primary-04"],
    default: ["bg-icon-basic-03", "text-basic-04"],
    warning: ["bg-icon-state-danger", "text-state-danger"]
  }[type];
  return /* @__PURE__ */ jsx("div", { className, id, children: /* @__PURE__ */ jsxs("div", { className: "flex", children: [
    /* @__PURE__ */ jsx(LineIcon, { icoColor: colorMap[0], icoName: "ico-warning-circle", type: "xs" }),
    /* @__PURE__ */ jsx("p", { className: cn("ml-1 body-sm"), children: text.split("\n").map((line, index) => /* @__PURE__ */ jsxs("span", { className: colorMap[1], children: [
      line,
      /* @__PURE__ */ jsx("br", {})
    ] }, index)) })
  ] }) });
};

export { InfoText };
